<template lang="pug">
.subscription(v-if="subscription != null")
  .subscription-status(v-html="subscriptionStatusHtml")

  .subscription-plan
    | Plano:&#32;
    span.magenta-text {{ planName }}

  .subscription-next-renewal-at(v-if="nextRenewalAt")
    | Próxima renovação:&#32;
    span.magenta-text {{ nextRenewalAt }}

  .subscription-next-renewal-at(v-if="renewalHasBeenCanceled")
    | Renovação:&#32;
    span.magenta-text cancelada

  .subscription-end-at(v-if="renewalHasBeenCanceled && endAt")
    | Ativa até:&#32;
    span.magenta-text {{ endAt }}

  .subscription-actions(v-if="showActions")
    Button(
      type="text",
      label="Ver boleto bancário",
      :to="bankSlipUrl",
      target="_blank",
      rel="noopener noreferrer",
      :disabled="!bankSlipUrl",
      size="small"
    )

    Button(
      type="text",
      label="Solicitar cancelamento",
      :to="{ name: 'cancel-subscription' }",
      size="small"
      :disabled="renewalHasBeenCanceled"
    )

.subscription(v-else)
  .no-subscription
    | Você não possui&#32;
    span.magenta-text nenhuma assinatura ativa!

    .no-subscription-action
      Button(:to="{ name: 'subscribe' }", label="Assine Já!", rounded)

</template>
<script setup lang="ts">
import type { PropType } from 'vue'
import type { PrimarySubscription } from '~/services/subscription/subscriptionService'

import dayjs from 'dayjs'
import { planName as planNameMapping } from '~/services/subscription/subscriptionService'
import { format } from 'crypto-js';

const props = defineProps({
  subscription: {
    type: Object as PropType<PrimarySubscription | null>,
  },
  showActions: {
    type: Boolean,
    default: false,
  },
})

const subscriptionStatusHtml = computed(() => {
  if (!props.subscription) {
    return ''
  }

  switch(props.subscription.status) {
    case 'WAITING':
      if (props.subscription.migratedFrom) {
        return 'Sua assinatura está <span class="magenta-text">ativa</span>'
      } else {
        return 'Sua assinatura está aguardando pela <span class="magenta-text">confirmação de pagamento</span>'
      }
    case 'ACTIVE':
      return 'Sua assinatura está <span class="magenta-text">ativa</span>'
    case 'PENDING':
    case 'UNPAID':
      return 'Sua assinatura possui <span class="magenta-text">pagamentos pendentes</span>'
    default:
      return 'Sua assinatura foi <span class="magenta-text">cancelada</span>'
  }
})

const planName = computed(() => {
  if (!props.subscription) {
    return ''
  }

  return planNameMapping[props.subscription.planId] ?? ""
})

const nextRenewalAt = computed(() => {
  if (!props.subscription?.nextRenewalAt) {
    return null
  }

  return formattedDate(props.subscription.nextRenewalAt)
})

const nextBillingAt = computed(() => {
  if (!props.subscription?.nextBillingAt) {
    return null
  }

  return formattedDate(props.subscription.nextBillingAt)
})

const renewalHasBeenCanceled = computed(() => {
  if (!props.subscription) {
    return false
  }

  return props.subscription.endAt != null
})

const endAt = computed(() => {
  if (!props.subscription?.endAt) {
    return null
  }

  return formattedDate(props.subscription.endAt)
})

const bankSlipUrl = computed(() => {
  return props.subscription?.pendingBankSlipUrl
})
</script>
<style lang="sass" scoped>
.subscription
  position: relative
  text-align: left
  font-size: 18px
  margin: 0 0 32px

  .subscription-actions
    margin-top: 16px

  .no-subscription
    .no-subscription-action
      text-align: center
      padding: 32px 0

      a
        width: 240px
        height: 48px
        border-radius: 24px
        font-size: 24px
        font-weight: bold
        box-shadow: 0 4px 24px 0 rgba(238, 61, 138, 0.4)
</style>